import React from 'react';

export type CuetSection = 'CUET_UG' | 'CUET_PG';

interface SectionSwitcherProps {
  activeSection: CuetSection;
  onChange: (section: CuetSection) => void;
  className?: string;
  ugLabel?: string;
  pgLabel?: string;
}

export function SectionSwitcher({
  activeSection,
  onChange,
  className,
  ugLabel = 'CUET (UG)',
  pgLabel = 'CUET (PG)',
}: SectionSwitcherProps) {
  return (
    <div className={['section-switcher', className].filter(Boolean).join(' ')}>
      <button
        type="button"
        className={`section-switcher-btn${activeSection === 'CUET_UG' ? ' is-active' : ''}`}
        onClick={() => onChange('CUET_UG')}
      >
        <span className="section-switcher-badge">1ST SECTION</span>
        <span>{ugLabel}</span>
        <span className="section-switcher-meta">(37 Papers)</span>
      </button>
      <button
        type="button"
        className={`section-switcher-btn${activeSection === 'CUET_PG' ? ' is-active' : ''}`}
        onClick={() => onChange('CUET_PG')}
      >
        <span className="section-switcher-badge">2ND SECTION</span>
        <span>{pgLabel}</span>
        <span className="section-switcher-meta">(157 Papers)</span>
      </button>
    </div>
  );
}
